/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { SortOrder } from '../models/sortOrder';
import { FeaTariffTemplate } from '../models/feaTariffTemplate';
import { FeaTariff } from '../models/feaTariff';

export class FeaTariffTemplateGetSchema {
  id: number = 0;
  feaTariffPrsAdditionalCostParametersPaginationPageNumber?: number;
  feaTariffPrsAdditionalCostParametersPaginationPageSize?: number;
  feaTariffPrsAdditionalCostParametersPaginationSortOrder?: SortOrder;
  feaTariffPrsAdditionalCostParametersPaginationSortColumn?: string;
  feaTariffPrsAdditionalCostParametersRangeMin?: number;
  feaTariffPrsAdditionalCostParametersRangeMax?: number;
  feaTariffPrsAdditionalCostParametersAdditionalCost?: string;
  feaTariffPrsAdditionalCostParametersDateRangeFromDateTime?: Date;
  feaTariffPrsAdditionalCostParametersDateRangeToDateTime?: Date;
  feaTariffPrsRepairCodeCostParametersPaginationPageNumber?: number;
  feaTariffPrsRepairCodeCostParametersPaginationPageSize?: number;
  feaTariffPrsRepairCodeCostParametersPaginationSortOrder?: SortOrder;
  feaTariffPrsRepairCodeCostParametersPaginationSortColumn?: string;
  feaTariffPrsRepairCodeCostParametersRepairId?: number;
  feaTariffPrsRepairCodeCostParametersRepairCode?: string;
  feaTariffPrsRepairCodeCostParametersCategory?: string;
  feaTariffPrsRepairCodeCostParametersRepairDescription?: string;
  feaTariffPrsRepairCodeCostParametersManHrs?: number;
  feaTariffPrsRepairCodeCostParametersMaterialCost?: number;
  feaTariffPrsRepairCodeCostParametersTotalCost?: number;
  feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime?: Date;
  feaTariffPrsRepairCodeCostParametersDateRangeToDateTime?: Date;
  feaTariffPrnMarkupCostParametersPaginationPageNumber?: number;
  feaTariffPrnMarkupCostParametersPaginationPageSize?: number;
  feaTariffPrnMarkupCostParametersPaginationSortOrder?: SortOrder;
  feaTariffPrnMarkupCostParametersPaginationSortColumn?: string;
  feaTariffPrnMarkupCostParametersLocationId?: string;
  feaTariffPrnMarkupCostParametersShopCode?: string;
  feaTariffPrnMarkupCostParametersMarkup?: number;
  feaTariffPrnMarkupCostParametersInlandShop?: string;
  feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded?: string;
  feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup?: string;
  feaTariffPrnMarkupCostParametersDateRangeFromDateTime?: Date;
  feaTariffPrnMarkupCostParametersDateRangeToDateTime?: Date;
  feaTariffPrnLiftChargeParametersPaginationPageNumber?: number;
  feaTariffPrnLiftChargeParametersPaginationPageSize?: number;
  feaTariffPrnLiftChargeParametersPaginationSortOrder?: SortOrder;
  feaTariffPrnLiftChargeParametersPaginationSortColumn?: string;
  feaTariffPrnLiftChargeParametersTariffId?: number;
  feaTariffPrnLiftChargeParametersEquipmentSize?: number;
  feaTariffPrnLiftChargeParametersShopCode?: string;
  feaTariffPrnLiftChargeParametersLocationId?: string;
  feaTariffPrnLiftChargeParametersLiftCharge?: string;
  feaTariffPrnLiftChargeParametersDateRangeFromDateTime?: Date;
  feaTariffPrnLiftChargeParametersDateRangeToDateTime?: Date;
  feaTariffPreManHourParametersPaginationPageNumber?: number;
  feaTariffPreManHourParametersPaginationPageSize?: number;
  feaTariffPreManHourParametersPaginationSortOrder?: SortOrder;
  feaTariffPreManHourParametersPaginationSortColumn?: string;
  feaTariffPreManHourParametersMode?: string;
  feaTariffPreManHourParametersRepairCode?: string;
  feaTariffPreManHourParametersRepairDescription?: string;
  feaTariffPreMaterialCostParametersPaginationPageNumber?: number;
  feaTariffPreMaterialCostParametersPaginationPageSize?: number;
  feaTariffPreMaterialCostParametersPaginationSortOrder?: SortOrder;
  feaTariffPreMaterialCostParametersPaginationSortColumn?: string;
  feaTariffPreMaterialCostParametersShopCode?: string;
  feaTariffPreMaterialCostParametersMode?: string;
  feaTariffPreMaterialCostParametersRepairCode?: string;
  feaTariffPreLabourRateParametersPaginationPageNumber?: number;
  feaTariffPreLabourRateParametersPaginationPageSize?: number;
  feaTariffPreLabourRateParametersPaginationSortOrder?: SortOrder;
  feaTariffPreLabourRateParametersPaginationSortColumn?: string;
  feaTariffPreLabourRateParametersShopCode?: string;
  feaTariffPreLabourRateParametersMode?: string;
  feaTariffPreMarkupParametersPaginationPageNumber?: number;
  feaTariffPreMarkupParametersPaginationPageSize?: number;
  feaTariffPreMarkupParametersPaginationSortOrder?: SortOrder;
  feaTariffPreMarkupParametersPaginationSortColumn?: string;
  feaTariffPreMarkupParametersLocationId?: string;
  feaTariffPreMarkupParametersShopCode?: string;
  feaTariffPreMarkupParametersMarkup?: number;
  feaTariffPreMarkupParametersInlandShop?: string;
}

@Injectable()
export class FeaTariffService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * This API will fetch count of FEA Tariffs
   *
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param templateName
   * @param region
   * @param currency
   * @param equipmentType
   * @param maintenanceRepairMode
   * @param dateRangeFromDateTime
   * @param dateRangeToDateTime
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaTariffsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<number>;
  public feaTariffsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<number>>;
  public feaTariffsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<number>>;
  public feaTariffsCountGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (paginationPageNumber !== undefined && paginationPageNumber !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>paginationPageNumber
      );
    }
    if (paginationPageSize !== undefined && paginationPageSize !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>paginationPageSize
      );
    }
    if (paginationSortOrder !== undefined && paginationSortOrder !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>paginationSortOrder
      );
    }
    if (paginationSortColumn !== undefined && paginationSortColumn !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>paginationSortColumn
      );
    }
    if (templateName !== undefined && templateName !== null) {
      queryParameters = queryParameters.set('TemplateName', <any>templateName);
    }
    if (region !== undefined && region !== null) {
      queryParameters = queryParameters.set('Region', <any>region);
    }
    if (currency !== undefined && currency !== null) {
      queryParameters = queryParameters.set('Currency', <any>currency);
    }
    if (equipmentType !== undefined && equipmentType !== null) {
      queryParameters = queryParameters.set(
        'EquipmentType',
        <any>equipmentType
      );
    }
    if (maintenanceRepairMode !== undefined && maintenanceRepairMode !== null) {
      queryParameters = queryParameters.set(
        'MaintenanceRepairMode',
        <any>maintenanceRepairMode
      );
    }
    if (dateRangeFromDateTime !== undefined && dateRangeFromDateTime !== null) {
      queryParameters = queryParameters.set(
        'DateRange.FromDateTime',
        <any>dateRangeFromDateTime.toISOString()
      );
    }
    if (dateRangeToDateTime !== undefined && dateRangeToDateTime !== null) {
      queryParameters = queryParameters.set(
        'DateRange.ToDateTime',
        <any>dateRangeToDateTime.toISOString()
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<number>(
      'get',
      `${this.basePath}/fea-tariffs/count`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch list of FEA Tariffs
   *
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param templateName
   * @param region
   * @param currency
   * @param equipmentType
   * @param maintenanceRepairMode
   * @param dateRangeFromDateTime
   * @param dateRangeToDateTime
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaTariffsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<FeaTariffTemplate>>;
  public feaTariffsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<FeaTariffTemplate>>>;
  public feaTariffsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<FeaTariffTemplate>>>;
  public feaTariffsGet(
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    templateName?: string,
    region?: string,
    currency?: string,
    equipmentType?: string,
    maintenanceRepairMode?: string,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (paginationPageNumber !== undefined && paginationPageNumber !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>paginationPageNumber
      );
    }
    if (paginationPageSize !== undefined && paginationPageSize !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>paginationPageSize
      );
    }
    if (paginationSortOrder !== undefined && paginationSortOrder !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>paginationSortOrder
      );
    }
    if (paginationSortColumn !== undefined && paginationSortColumn !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>paginationSortColumn
      );
    }
    if (templateName !== undefined && templateName !== null) {
      queryParameters = queryParameters.set('TemplateName', <any>templateName);
    }
    if (region !== undefined && region !== null) {
      queryParameters = queryParameters.set('Region', <any>region);
    }
    if (currency !== undefined && currency !== null) {
      queryParameters = queryParameters.set('Currency', <any>currency);
    }
    if (equipmentType !== undefined && equipmentType !== null) {
      queryParameters = queryParameters.set(
        'EquipmentType',
        <any>equipmentType
      );
    }
    if (maintenanceRepairMode !== undefined && maintenanceRepairMode !== null) {
      queryParameters = queryParameters.set(
        'MaintenanceRepairMode',
        <any>maintenanceRepairMode
      );
    }
    if (dateRangeFromDateTime !== undefined && dateRangeFromDateTime !== null) {
      queryParameters = queryParameters.set(
        'DateRange.FromDateTime',
        <any>dateRangeFromDateTime.toISOString()
      );
    }
    if (dateRangeToDateTime !== undefined && dateRangeToDateTime !== null) {
      queryParameters = queryParameters.set(
        'DateRange.ToDateTime',
        <any>dateRangeToDateTime.toISOString()
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<FeaTariffTemplate>>(
      'get',
      `${this.basePath}/fea-tariffs`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves a specific tariff by its unique identifier.
   * This method requires authorization with the &#x60;RecoveryRead&#x60; policy. It maps to              API version 1.0 and supports HTTP GET requests.
   * @param id The unique identifier of the tariff to retrieve.
   * @param feaTariffPrsAdditionalCostParametersPaginationPageNumber
   * @param feaTariffPrsAdditionalCostParametersPaginationPageSize
   * @param feaTariffPrsAdditionalCostParametersPaginationSortOrder
   * @param feaTariffPrsAdditionalCostParametersPaginationSortColumn
   * @param feaTariffPrsAdditionalCostParametersRangeMin
   * @param feaTariffPrsAdditionalCostParametersRangeMax
   * @param feaTariffPrsAdditionalCostParametersAdditionalCost
   * @param feaTariffPrsAdditionalCostParametersDateRangeFromDateTime
   * @param feaTariffPrsAdditionalCostParametersDateRangeToDateTime
   * @param feaTariffPrsRepairCodeCostParametersPaginationPageNumber
   * @param feaTariffPrsRepairCodeCostParametersPaginationPageSize
   * @param feaTariffPrsRepairCodeCostParametersPaginationSortOrder
   * @param feaTariffPrsRepairCodeCostParametersPaginationSortColumn
   * @param feaTariffPrsRepairCodeCostParametersRepairId
   * @param feaTariffPrsRepairCodeCostParametersRepairCode
   * @param feaTariffPrsRepairCodeCostParametersCategory
   * @param feaTariffPrsRepairCodeCostParametersRepairDescription
   * @param feaTariffPrsRepairCodeCostParametersManHrs
   * @param feaTariffPrsRepairCodeCostParametersMaterialCost
   * @param feaTariffPrsRepairCodeCostParametersTotalCost
   * @param feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime
   * @param feaTariffPrsRepairCodeCostParametersDateRangeToDateTime
   * @param feaTariffPrnMarkupCostParametersPaginationPageNumber
   * @param feaTariffPrnMarkupCostParametersPaginationPageSize
   * @param feaTariffPrnMarkupCostParametersPaginationSortOrder
   * @param feaTariffPrnMarkupCostParametersPaginationSortColumn
   * @param feaTariffPrnMarkupCostParametersLocationId
   * @param feaTariffPrnMarkupCostParametersShopCode
   * @param feaTariffPrnMarkupCostParametersMarkup
   * @param feaTariffPrnMarkupCostParametersInlandShop
   * @param feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded
   * @param feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup
   * @param feaTariffPrnMarkupCostParametersDateRangeFromDateTime
   * @param feaTariffPrnMarkupCostParametersDateRangeToDateTime
   * @param feaTariffPrnLiftChargeParametersPaginationPageNumber
   * @param feaTariffPrnLiftChargeParametersPaginationPageSize
   * @param feaTariffPrnLiftChargeParametersPaginationSortOrder
   * @param feaTariffPrnLiftChargeParametersPaginationSortColumn
   * @param feaTariffPrnLiftChargeParametersTariffId
   * @param feaTariffPrnLiftChargeParametersEquipmentSize
   * @param feaTariffPrnLiftChargeParametersShopCode
   * @param feaTariffPrnLiftChargeParametersLocationId
   * @param feaTariffPrnLiftChargeParametersLiftCharge
   * @param feaTariffPrnLiftChargeParametersDateRangeFromDateTime
   * @param feaTariffPrnLiftChargeParametersDateRangeToDateTime
   * @param feaTariffPreManHourParametersPaginationPageNumber
   * @param feaTariffPreManHourParametersPaginationPageSize
   * @param feaTariffPreManHourParametersPaginationSortOrder
   * @param feaTariffPreManHourParametersPaginationSortColumn
   * @param feaTariffPreManHourParametersMode
   * @param feaTariffPreManHourParametersRepairCode
   * @param feaTariffPreManHourParametersRepairDescription
   * @param feaTariffPreMaterialCostParametersPaginationPageNumber
   * @param feaTariffPreMaterialCostParametersPaginationPageSize
   * @param feaTariffPreMaterialCostParametersPaginationSortOrder
   * @param feaTariffPreMaterialCostParametersPaginationSortColumn
   * @param feaTariffPreMaterialCostParametersShopCode
   * @param feaTariffPreMaterialCostParametersMode
   * @param feaTariffPreMaterialCostParametersRepairCode
   * @param feaTariffPreLabourRateParametersPaginationPageNumber
   * @param feaTariffPreLabourRateParametersPaginationPageSize
   * @param feaTariffPreLabourRateParametersPaginationSortOrder
   * @param feaTariffPreLabourRateParametersPaginationSortColumn
   * @param feaTariffPreLabourRateParametersShopCode
   * @param feaTariffPreLabourRateParametersMode
   * @param feaTariffPreMarkupParametersPaginationPageNumber
   * @param feaTariffPreMarkupParametersPaginationPageSize
   * @param feaTariffPreMarkupParametersPaginationSortOrder
   * @param feaTariffPreMarkupParametersPaginationSortColumn
   * @param feaTariffPreMarkupParametersLocationId
   * @param feaTariffPreMarkupParametersShopCode
   * @param feaTariffPreMarkupParametersMarkup
   * @param feaTariffPreMarkupParametersInlandShop
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaTariffsIdGet(
    {
      id,
      feaTariffPrsAdditionalCostParametersPaginationPageNumber,
      feaTariffPrsAdditionalCostParametersPaginationPageSize,
      feaTariffPrsAdditionalCostParametersPaginationSortOrder,
      feaTariffPrsAdditionalCostParametersPaginationSortColumn,
      feaTariffPrsAdditionalCostParametersRangeMin,
      feaTariffPrsAdditionalCostParametersRangeMax,
      feaTariffPrsAdditionalCostParametersAdditionalCost,
      feaTariffPrsAdditionalCostParametersDateRangeFromDateTime,
      feaTariffPrsAdditionalCostParametersDateRangeToDateTime,
      feaTariffPrsRepairCodeCostParametersPaginationPageNumber,
      feaTariffPrsRepairCodeCostParametersPaginationPageSize,
      feaTariffPrsRepairCodeCostParametersPaginationSortOrder,
      feaTariffPrsRepairCodeCostParametersPaginationSortColumn,
      feaTariffPrsRepairCodeCostParametersRepairId,
      feaTariffPrsRepairCodeCostParametersRepairCode,
      feaTariffPrsRepairCodeCostParametersCategory,
      feaTariffPrsRepairCodeCostParametersRepairDescription,
      feaTariffPrsRepairCodeCostParametersManHrs,
      feaTariffPrsRepairCodeCostParametersMaterialCost,
      feaTariffPrsRepairCodeCostParametersTotalCost,
      feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime,
      feaTariffPrsRepairCodeCostParametersDateRangeToDateTime,
      feaTariffPrnMarkupCostParametersPaginationPageNumber,
      feaTariffPrnMarkupCostParametersPaginationPageSize,
      feaTariffPrnMarkupCostParametersPaginationSortOrder,
      feaTariffPrnMarkupCostParametersPaginationSortColumn,
      feaTariffPrnMarkupCostParametersLocationId,
      feaTariffPrnMarkupCostParametersShopCode,
      feaTariffPrnMarkupCostParametersMarkup,
      feaTariffPrnMarkupCostParametersInlandShop,
      feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded,
      feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup,
      feaTariffPrnMarkupCostParametersDateRangeFromDateTime,
      feaTariffPrnMarkupCostParametersDateRangeToDateTime,
      feaTariffPrnLiftChargeParametersPaginationPageNumber,
      feaTariffPrnLiftChargeParametersPaginationPageSize,
      feaTariffPrnLiftChargeParametersPaginationSortOrder,
      feaTariffPrnLiftChargeParametersPaginationSortColumn,
      feaTariffPrnLiftChargeParametersTariffId,
      feaTariffPrnLiftChargeParametersEquipmentSize,
      feaTariffPrnLiftChargeParametersShopCode,
      feaTariffPrnLiftChargeParametersLocationId,
      feaTariffPrnLiftChargeParametersLiftCharge,
      feaTariffPrnLiftChargeParametersDateRangeFromDateTime,
      feaTariffPrnLiftChargeParametersDateRangeToDateTime,
      feaTariffPreManHourParametersPaginationPageNumber,
      feaTariffPreManHourParametersPaginationPageSize,
      feaTariffPreManHourParametersPaginationSortOrder,
      feaTariffPreManHourParametersPaginationSortColumn,
      feaTariffPreManHourParametersMode,
      feaTariffPreManHourParametersRepairCode,
      feaTariffPreManHourParametersRepairDescription,
      feaTariffPreMaterialCostParametersPaginationPageNumber,
      feaTariffPreMaterialCostParametersPaginationPageSize,
      feaTariffPreMaterialCostParametersPaginationSortOrder,
      feaTariffPreMaterialCostParametersPaginationSortColumn,
      feaTariffPreMaterialCostParametersShopCode,
      feaTariffPreMaterialCostParametersMode,
      feaTariffPreMaterialCostParametersRepairCode,
      feaTariffPreLabourRateParametersPaginationPageNumber,
      feaTariffPreLabourRateParametersPaginationPageSize,
      feaTariffPreLabourRateParametersPaginationSortOrder,
      feaTariffPreLabourRateParametersPaginationSortColumn,
      feaTariffPreLabourRateParametersShopCode,
      feaTariffPreLabourRateParametersMode,
      feaTariffPreMarkupParametersPaginationPageNumber,
      feaTariffPreMarkupParametersPaginationPageSize,
      feaTariffPreMarkupParametersPaginationSortOrder,
      feaTariffPreMarkupParametersPaginationSortColumn,
      feaTariffPreMarkupParametersLocationId,
      feaTariffPreMarkupParametersShopCode,
      feaTariffPreMarkupParametersMarkup,
      feaTariffPreMarkupParametersInlandShop,
    }: FeaTariffTemplateGetSchema,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<FeaTariff>;
  public feaTariffsIdGet(
    {
      id,
      feaTariffPrsAdditionalCostParametersPaginationPageNumber,
      feaTariffPrsAdditionalCostParametersPaginationPageSize,
      feaTariffPrsAdditionalCostParametersPaginationSortOrder,
      feaTariffPrsAdditionalCostParametersPaginationSortColumn,
      feaTariffPrsAdditionalCostParametersRangeMin,
      feaTariffPrsAdditionalCostParametersRangeMax,
      feaTariffPrsAdditionalCostParametersAdditionalCost,
      feaTariffPrsAdditionalCostParametersDateRangeFromDateTime,
      feaTariffPrsAdditionalCostParametersDateRangeToDateTime,
      feaTariffPrsRepairCodeCostParametersPaginationPageNumber,
      feaTariffPrsRepairCodeCostParametersPaginationPageSize,
      feaTariffPrsRepairCodeCostParametersPaginationSortOrder,
      feaTariffPrsRepairCodeCostParametersPaginationSortColumn,
      feaTariffPrsRepairCodeCostParametersRepairId,
      feaTariffPrsRepairCodeCostParametersRepairCode,
      feaTariffPrsRepairCodeCostParametersCategory,
      feaTariffPrsRepairCodeCostParametersRepairDescription,
      feaTariffPrsRepairCodeCostParametersManHrs,
      feaTariffPrsRepairCodeCostParametersMaterialCost,
      feaTariffPrsRepairCodeCostParametersTotalCost,
      feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime,
      feaTariffPrsRepairCodeCostParametersDateRangeToDateTime,
      feaTariffPrnMarkupCostParametersPaginationPageNumber,
      feaTariffPrnMarkupCostParametersPaginationPageSize,
      feaTariffPrnMarkupCostParametersPaginationSortOrder,
      feaTariffPrnMarkupCostParametersPaginationSortColumn,
      feaTariffPrnMarkupCostParametersLocationId,
      feaTariffPrnMarkupCostParametersShopCode,
      feaTariffPrnMarkupCostParametersMarkup,
      feaTariffPrnMarkupCostParametersInlandShop,
      feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded,
      feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup,
      feaTariffPrnMarkupCostParametersDateRangeFromDateTime,
      feaTariffPrnMarkupCostParametersDateRangeToDateTime,
      feaTariffPrnLiftChargeParametersPaginationPageNumber,
      feaTariffPrnLiftChargeParametersPaginationPageSize,
      feaTariffPrnLiftChargeParametersPaginationSortOrder,
      feaTariffPrnLiftChargeParametersPaginationSortColumn,
      feaTariffPrnLiftChargeParametersTariffId,
      feaTariffPrnLiftChargeParametersEquipmentSize,
      feaTariffPrnLiftChargeParametersShopCode,
      feaTariffPrnLiftChargeParametersLocationId,
      feaTariffPrnLiftChargeParametersLiftCharge,
      feaTariffPrnLiftChargeParametersDateRangeFromDateTime,
      feaTariffPrnLiftChargeParametersDateRangeToDateTime,
      feaTariffPreManHourParametersPaginationPageNumber,
      feaTariffPreManHourParametersPaginationPageSize,
      feaTariffPreManHourParametersPaginationSortOrder,
      feaTariffPreManHourParametersPaginationSortColumn,
      feaTariffPreManHourParametersMode,
      feaTariffPreManHourParametersRepairCode,
      feaTariffPreManHourParametersRepairDescription,
      feaTariffPreMaterialCostParametersPaginationPageNumber,
      feaTariffPreMaterialCostParametersPaginationPageSize,
      feaTariffPreMaterialCostParametersPaginationSortOrder,
      feaTariffPreMaterialCostParametersPaginationSortColumn,
      feaTariffPreMaterialCostParametersShopCode,
      feaTariffPreMaterialCostParametersMode,
      feaTariffPreMaterialCostParametersRepairCode,
      feaTariffPreLabourRateParametersPaginationPageNumber,
      feaTariffPreLabourRateParametersPaginationPageSize,
      feaTariffPreLabourRateParametersPaginationSortOrder,
      feaTariffPreLabourRateParametersPaginationSortColumn,
      feaTariffPreLabourRateParametersShopCode,
      feaTariffPreLabourRateParametersMode,
      feaTariffPreMarkupParametersPaginationPageNumber,
      feaTariffPreMarkupParametersPaginationPageSize,
      feaTariffPreMarkupParametersPaginationSortOrder,
      feaTariffPreMarkupParametersPaginationSortColumn,
      feaTariffPreMarkupParametersLocationId,
      feaTariffPreMarkupParametersShopCode,
      feaTariffPreMarkupParametersMarkup,
      feaTariffPreMarkupParametersInlandShop,
    }: FeaTariffTemplateGetSchema,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<FeaTariff>>;
  public feaTariffsIdGet(
    {
      id,
      feaTariffPrsAdditionalCostParametersPaginationPageNumber,
      feaTariffPrsAdditionalCostParametersPaginationPageSize,
      feaTariffPrsAdditionalCostParametersPaginationSortOrder,
      feaTariffPrsAdditionalCostParametersPaginationSortColumn,
      feaTariffPrsAdditionalCostParametersRangeMin,
      feaTariffPrsAdditionalCostParametersRangeMax,
      feaTariffPrsAdditionalCostParametersAdditionalCost,
      feaTariffPrsAdditionalCostParametersDateRangeFromDateTime,
      feaTariffPrsAdditionalCostParametersDateRangeToDateTime,
      feaTariffPrsRepairCodeCostParametersPaginationPageNumber,
      feaTariffPrsRepairCodeCostParametersPaginationPageSize,
      feaTariffPrsRepairCodeCostParametersPaginationSortOrder,
      feaTariffPrsRepairCodeCostParametersPaginationSortColumn,
      feaTariffPrsRepairCodeCostParametersRepairId,
      feaTariffPrsRepairCodeCostParametersRepairCode,
      feaTariffPrsRepairCodeCostParametersCategory,
      feaTariffPrsRepairCodeCostParametersRepairDescription,
      feaTariffPrsRepairCodeCostParametersManHrs,
      feaTariffPrsRepairCodeCostParametersMaterialCost,
      feaTariffPrsRepairCodeCostParametersTotalCost,
      feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime,
      feaTariffPrsRepairCodeCostParametersDateRangeToDateTime,
      feaTariffPrnMarkupCostParametersPaginationPageNumber,
      feaTariffPrnMarkupCostParametersPaginationPageSize,
      feaTariffPrnMarkupCostParametersPaginationSortOrder,
      feaTariffPrnMarkupCostParametersPaginationSortColumn,
      feaTariffPrnMarkupCostParametersLocationId,
      feaTariffPrnMarkupCostParametersShopCode,
      feaTariffPrnMarkupCostParametersMarkup,
      feaTariffPrnMarkupCostParametersInlandShop,
      feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded,
      feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup,
      feaTariffPrnMarkupCostParametersDateRangeFromDateTime,
      feaTariffPrnMarkupCostParametersDateRangeToDateTime,
      feaTariffPrnLiftChargeParametersPaginationPageNumber,
      feaTariffPrnLiftChargeParametersPaginationPageSize,
      feaTariffPrnLiftChargeParametersPaginationSortOrder,
      feaTariffPrnLiftChargeParametersPaginationSortColumn,
      feaTariffPrnLiftChargeParametersTariffId,
      feaTariffPrnLiftChargeParametersEquipmentSize,
      feaTariffPrnLiftChargeParametersShopCode,
      feaTariffPrnLiftChargeParametersLocationId,
      feaTariffPrnLiftChargeParametersLiftCharge,
      feaTariffPrnLiftChargeParametersDateRangeFromDateTime,
      feaTariffPrnLiftChargeParametersDateRangeToDateTime,
      feaTariffPreManHourParametersPaginationPageNumber,
      feaTariffPreManHourParametersPaginationPageSize,
      feaTariffPreManHourParametersPaginationSortOrder,
      feaTariffPreManHourParametersPaginationSortColumn,
      feaTariffPreManHourParametersMode,
      feaTariffPreManHourParametersRepairCode,
      feaTariffPreManHourParametersRepairDescription,
      feaTariffPreMaterialCostParametersPaginationPageNumber,
      feaTariffPreMaterialCostParametersPaginationPageSize,
      feaTariffPreMaterialCostParametersPaginationSortOrder,
      feaTariffPreMaterialCostParametersPaginationSortColumn,
      feaTariffPreMaterialCostParametersShopCode,
      feaTariffPreMaterialCostParametersMode,
      feaTariffPreMaterialCostParametersRepairCode,
      feaTariffPreLabourRateParametersPaginationPageNumber,
      feaTariffPreLabourRateParametersPaginationPageSize,
      feaTariffPreLabourRateParametersPaginationSortOrder,
      feaTariffPreLabourRateParametersPaginationSortColumn,
      feaTariffPreLabourRateParametersShopCode,
      feaTariffPreLabourRateParametersMode,
      feaTariffPreMarkupParametersPaginationPageNumber,
      feaTariffPreMarkupParametersPaginationPageSize,
      feaTariffPreMarkupParametersPaginationSortOrder,
      feaTariffPreMarkupParametersPaginationSortColumn,
      feaTariffPreMarkupParametersLocationId,
      feaTariffPreMarkupParametersShopCode,
      feaTariffPreMarkupParametersMarkup,
      feaTariffPreMarkupParametersInlandShop,
    }: FeaTariffTemplateGetSchema,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<FeaTariff>>;
  public feaTariffsIdGet(
    {
      id,
      feaTariffPrsAdditionalCostParametersPaginationPageNumber,
      feaTariffPrsAdditionalCostParametersPaginationPageSize,
      feaTariffPrsAdditionalCostParametersPaginationSortOrder,
      feaTariffPrsAdditionalCostParametersPaginationSortColumn,
      feaTariffPrsAdditionalCostParametersRangeMin,
      feaTariffPrsAdditionalCostParametersRangeMax,
      feaTariffPrsAdditionalCostParametersAdditionalCost,
      feaTariffPrsAdditionalCostParametersDateRangeFromDateTime,
      feaTariffPrsAdditionalCostParametersDateRangeToDateTime,
      feaTariffPrsRepairCodeCostParametersPaginationPageNumber,
      feaTariffPrsRepairCodeCostParametersPaginationPageSize,
      feaTariffPrsRepairCodeCostParametersPaginationSortOrder,
      feaTariffPrsRepairCodeCostParametersPaginationSortColumn,
      feaTariffPrsRepairCodeCostParametersRepairId,
      feaTariffPrsRepairCodeCostParametersRepairCode,
      feaTariffPrsRepairCodeCostParametersCategory,
      feaTariffPrsRepairCodeCostParametersRepairDescription,
      feaTariffPrsRepairCodeCostParametersManHrs,
      feaTariffPrsRepairCodeCostParametersMaterialCost,
      feaTariffPrsRepairCodeCostParametersTotalCost,
      feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime,
      feaTariffPrsRepairCodeCostParametersDateRangeToDateTime,
      feaTariffPrnMarkupCostParametersPaginationPageNumber,
      feaTariffPrnMarkupCostParametersPaginationPageSize,
      feaTariffPrnMarkupCostParametersPaginationSortOrder,
      feaTariffPrnMarkupCostParametersPaginationSortColumn,
      feaTariffPrnMarkupCostParametersLocationId,
      feaTariffPrnMarkupCostParametersShopCode,
      feaTariffPrnMarkupCostParametersMarkup,
      feaTariffPrnMarkupCostParametersInlandShop,
      feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded,
      feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup,
      feaTariffPrnMarkupCostParametersDateRangeFromDateTime,
      feaTariffPrnMarkupCostParametersDateRangeToDateTime,
      feaTariffPrnLiftChargeParametersPaginationPageNumber,
      feaTariffPrnLiftChargeParametersPaginationPageSize,
      feaTariffPrnLiftChargeParametersPaginationSortOrder,
      feaTariffPrnLiftChargeParametersPaginationSortColumn,
      feaTariffPrnLiftChargeParametersTariffId,
      feaTariffPrnLiftChargeParametersEquipmentSize,
      feaTariffPrnLiftChargeParametersShopCode,
      feaTariffPrnLiftChargeParametersLocationId,
      feaTariffPrnLiftChargeParametersLiftCharge,
      feaTariffPrnLiftChargeParametersDateRangeFromDateTime,
      feaTariffPrnLiftChargeParametersDateRangeToDateTime,
      feaTariffPreManHourParametersPaginationPageNumber,
      feaTariffPreManHourParametersPaginationPageSize,
      feaTariffPreManHourParametersPaginationSortOrder,
      feaTariffPreManHourParametersPaginationSortColumn,
      feaTariffPreManHourParametersMode,
      feaTariffPreManHourParametersRepairCode,
      feaTariffPreManHourParametersRepairDescription,
      feaTariffPreMaterialCostParametersPaginationPageNumber,
      feaTariffPreMaterialCostParametersPaginationPageSize,
      feaTariffPreMaterialCostParametersPaginationSortOrder,
      feaTariffPreMaterialCostParametersPaginationSortColumn,
      feaTariffPreMaterialCostParametersShopCode,
      feaTariffPreMaterialCostParametersMode,
      feaTariffPreMaterialCostParametersRepairCode,
      feaTariffPreLabourRateParametersPaginationPageNumber,
      feaTariffPreLabourRateParametersPaginationPageSize,
      feaTariffPreLabourRateParametersPaginationSortOrder,
      feaTariffPreLabourRateParametersPaginationSortColumn,
      feaTariffPreLabourRateParametersShopCode,
      feaTariffPreLabourRateParametersMode,
      feaTariffPreMarkupParametersPaginationPageNumber,
      feaTariffPreMarkupParametersPaginationPageSize,
      feaTariffPreMarkupParametersPaginationSortOrder,
      feaTariffPreMarkupParametersPaginationSortColumn,
      feaTariffPreMarkupParametersLocationId,
      feaTariffPreMarkupParametersShopCode,
      feaTariffPreMarkupParametersMarkup,
      feaTariffPreMarkupParametersInlandShop,
    }: FeaTariffTemplateGetSchema,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling feaTariffsIdGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (
      feaTariffPrsAdditionalCostParametersPaginationPageNumber !== undefined &&
      feaTariffPrsAdditionalCostParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.Pagination.PageNumber',
        <any>feaTariffPrsAdditionalCostParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersPaginationPageSize !== undefined &&
      feaTariffPrsAdditionalCostParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.Pagination.PageSize',
        <any>feaTariffPrsAdditionalCostParametersPaginationPageSize
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersPaginationSortOrder !== undefined &&
      feaTariffPrsAdditionalCostParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.Pagination.SortOrder',
        <any>feaTariffPrsAdditionalCostParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersPaginationSortColumn !== undefined &&
      feaTariffPrsAdditionalCostParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.Pagination.SortColumn',
        <any>feaTariffPrsAdditionalCostParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersRangeMin !== undefined &&
      feaTariffPrsAdditionalCostParametersRangeMin !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.RangeMin',
        <any>feaTariffPrsAdditionalCostParametersRangeMin
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersRangeMax !== undefined &&
      feaTariffPrsAdditionalCostParametersRangeMax !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.RangeMax',
        <any>feaTariffPrsAdditionalCostParametersRangeMax
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersAdditionalCost !== undefined &&
      feaTariffPrsAdditionalCostParametersAdditionalCost !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.AdditionalCost',
        <any>feaTariffPrsAdditionalCostParametersAdditionalCost
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersDateRangeFromDateTime !== undefined &&
      feaTariffPrsAdditionalCostParametersDateRangeFromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.DateRange.FromDateTime',
        <any>(
          feaTariffPrsAdditionalCostParametersDateRangeFromDateTime.toISOString()
        )
      );
    }
    if (
      feaTariffPrsAdditionalCostParametersDateRangeToDateTime !== undefined &&
      feaTariffPrsAdditionalCostParametersDateRangeToDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsAdditionalCostParameters.DateRange.ToDateTime',
        <any>(
          feaTariffPrsAdditionalCostParametersDateRangeToDateTime.toISOString()
        )
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersPaginationPageNumber !== undefined &&
      feaTariffPrsRepairCodeCostParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.Pagination.PageNumber',
        <any>feaTariffPrsRepairCodeCostParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersPaginationPageSize !== undefined &&
      feaTariffPrsRepairCodeCostParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.Pagination.PageSize',
        <any>feaTariffPrsRepairCodeCostParametersPaginationPageSize
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersPaginationSortOrder !== undefined &&
      feaTariffPrsRepairCodeCostParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.Pagination.SortOrder',
        <any>feaTariffPrsRepairCodeCostParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersPaginationSortColumn !== undefined &&
      feaTariffPrsRepairCodeCostParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.Pagination.SortColumn',
        <any>feaTariffPrsRepairCodeCostParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersRepairId !== undefined &&
      feaTariffPrsRepairCodeCostParametersRepairId !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.RepairId',
        <any>feaTariffPrsRepairCodeCostParametersRepairId
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersRepairCode !== undefined &&
      feaTariffPrsRepairCodeCostParametersRepairCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.RepairCode',
        <any>feaTariffPrsRepairCodeCostParametersRepairCode
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersCategory !== undefined &&
      feaTariffPrsRepairCodeCostParametersCategory !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.Category',
        <any>feaTariffPrsRepairCodeCostParametersCategory
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersRepairDescription !== undefined &&
      feaTariffPrsRepairCodeCostParametersRepairDescription !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.RepairDescription',
        <any>feaTariffPrsRepairCodeCostParametersRepairDescription
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersManHrs !== undefined &&
      feaTariffPrsRepairCodeCostParametersManHrs !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.ManHrs',
        <any>feaTariffPrsRepairCodeCostParametersManHrs
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersMaterialCost !== undefined &&
      feaTariffPrsRepairCodeCostParametersMaterialCost !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.MaterialCost',
        <any>feaTariffPrsRepairCodeCostParametersMaterialCost
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersTotalCost !== undefined &&
      feaTariffPrsRepairCodeCostParametersTotalCost !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.TotalCost',
        <any>feaTariffPrsRepairCodeCostParametersTotalCost
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime !== undefined &&
      feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.DateRange.FromDateTime',
        <any>(
          feaTariffPrsRepairCodeCostParametersDateRangeFromDateTime.toISOString()
        )
      );
    }
    if (
      feaTariffPrsRepairCodeCostParametersDateRangeToDateTime !== undefined &&
      feaTariffPrsRepairCodeCostParametersDateRangeToDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrsRepairCodeCostParameters.DateRange.ToDateTime',
        <any>(
          feaTariffPrsRepairCodeCostParametersDateRangeToDateTime.toISOString()
        )
      );
    }
    if (
      feaTariffPrnMarkupCostParametersPaginationPageNumber !== undefined &&
      feaTariffPrnMarkupCostParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.Pagination.PageNumber',
        <any>feaTariffPrnMarkupCostParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPrnMarkupCostParametersPaginationPageSize !== undefined &&
      feaTariffPrnMarkupCostParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.Pagination.PageSize',
        <any>feaTariffPrnMarkupCostParametersPaginationPageSize
      );
    }
    if (
      feaTariffPrnMarkupCostParametersPaginationSortOrder !== undefined &&
      feaTariffPrnMarkupCostParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.Pagination.SortOrder',
        <any>feaTariffPrnMarkupCostParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPrnMarkupCostParametersPaginationSortColumn !== undefined &&
      feaTariffPrnMarkupCostParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.Pagination.SortColumn',
        <any>feaTariffPrnMarkupCostParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPrnMarkupCostParametersLocationId !== undefined &&
      feaTariffPrnMarkupCostParametersLocationId !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.LocationId',
        <any>feaTariffPrnMarkupCostParametersLocationId
      );
    }
    if (
      feaTariffPrnMarkupCostParametersShopCode !== undefined &&
      feaTariffPrnMarkupCostParametersShopCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.ShopCode',
        <any>feaTariffPrnMarkupCostParametersShopCode
      );
    }
    if (
      feaTariffPrnMarkupCostParametersMarkup !== undefined &&
      feaTariffPrnMarkupCostParametersMarkup !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.Markup',
        <any>feaTariffPrnMarkupCostParametersMarkup
      );
    }
    if (
      feaTariffPrnMarkupCostParametersInlandShop !== undefined &&
      feaTariffPrnMarkupCostParametersInlandShop !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.InlandShop',
        <any>feaTariffPrnMarkupCostParametersInlandShop
      );
    }
    if (
      feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded !== undefined &&
      feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.LiftChargeMarkupExcluded',
        <any>feaTariffPrnMarkupCostParametersLiftChargeMarkupExcluded
      );
    }
    if (
      feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup !== undefined &&
      feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.StsCodeWithoutMarkup',
        <any>feaTariffPrnMarkupCostParametersStsCodeWithoutMarkup
      );
    }
    if (
      feaTariffPrnMarkupCostParametersDateRangeFromDateTime !== undefined &&
      feaTariffPrnMarkupCostParametersDateRangeFromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.DateRange.FromDateTime',
        <any>feaTariffPrnMarkupCostParametersDateRangeFromDateTime.toISOString()
      );
    }
    if (
      feaTariffPrnMarkupCostParametersDateRangeToDateTime !== undefined &&
      feaTariffPrnMarkupCostParametersDateRangeToDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnMarkupCostParameters.DateRange.ToDateTime',
        <any>feaTariffPrnMarkupCostParametersDateRangeToDateTime.toISOString()
      );
    }
    if (
      feaTariffPrnLiftChargeParametersPaginationPageNumber !== undefined &&
      feaTariffPrnLiftChargeParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.Pagination.PageNumber',
        <any>feaTariffPrnLiftChargeParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPrnLiftChargeParametersPaginationPageSize !== undefined &&
      feaTariffPrnLiftChargeParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.Pagination.PageSize',
        <any>feaTariffPrnLiftChargeParametersPaginationPageSize
      );
    }
    if (
      feaTariffPrnLiftChargeParametersPaginationSortOrder !== undefined &&
      feaTariffPrnLiftChargeParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.Pagination.SortOrder',
        <any>feaTariffPrnLiftChargeParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPrnLiftChargeParametersPaginationSortColumn !== undefined &&
      feaTariffPrnLiftChargeParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.Pagination.SortColumn',
        <any>feaTariffPrnLiftChargeParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPrnLiftChargeParametersTariffId !== undefined &&
      feaTariffPrnLiftChargeParametersTariffId !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.TariffId',
        <any>feaTariffPrnLiftChargeParametersTariffId
      );
    }
    if (
      feaTariffPrnLiftChargeParametersEquipmentSize !== undefined &&
      feaTariffPrnLiftChargeParametersEquipmentSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.EquipmentSize',
        <any>feaTariffPrnLiftChargeParametersEquipmentSize
      );
    }
    if (
      feaTariffPrnLiftChargeParametersShopCode !== undefined &&
      feaTariffPrnLiftChargeParametersShopCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.ShopCode',
        <any>feaTariffPrnLiftChargeParametersShopCode
      );
    }
    if (
      feaTariffPrnLiftChargeParametersLocationId !== undefined &&
      feaTariffPrnLiftChargeParametersLocationId !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.LocationId',
        <any>feaTariffPrnLiftChargeParametersLocationId
      );
    }
    if (
      feaTariffPrnLiftChargeParametersLiftCharge !== undefined &&
      feaTariffPrnLiftChargeParametersLiftCharge !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.LiftCharge',
        <any>feaTariffPrnLiftChargeParametersLiftCharge
      );
    }
    if (
      feaTariffPrnLiftChargeParametersDateRangeFromDateTime !== undefined &&
      feaTariffPrnLiftChargeParametersDateRangeFromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.DateRange.FromDateTime',
        <any>feaTariffPrnLiftChargeParametersDateRangeFromDateTime.toISOString()
      );
    }
    if (
      feaTariffPrnLiftChargeParametersDateRangeToDateTime !== undefined &&
      feaTariffPrnLiftChargeParametersDateRangeToDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPrnLiftChargeParameters.DateRange.ToDateTime',
        <any>feaTariffPrnLiftChargeParametersDateRangeToDateTime.toISOString()
      );
    }
    if (
      feaTariffPreManHourParametersPaginationPageNumber !== undefined &&
      feaTariffPreManHourParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.Pagination.PageNumber',
        <any>feaTariffPreManHourParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPreManHourParametersPaginationPageSize !== undefined &&
      feaTariffPreManHourParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.Pagination.PageSize',
        <any>feaTariffPreManHourParametersPaginationPageSize
      );
    }
    if (
      feaTariffPreManHourParametersPaginationSortOrder !== undefined &&
      feaTariffPreManHourParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.Pagination.SortOrder',
        <any>feaTariffPreManHourParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPreManHourParametersPaginationSortColumn !== undefined &&
      feaTariffPreManHourParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.Pagination.SortColumn',
        <any>feaTariffPreManHourParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPreManHourParametersMode !== undefined &&
      feaTariffPreManHourParametersMode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.Mode',
        <any>feaTariffPreManHourParametersMode
      );
    }
    if (
      feaTariffPreManHourParametersRepairCode !== undefined &&
      feaTariffPreManHourParametersRepairCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.RepairCode',
        <any>feaTariffPreManHourParametersRepairCode
      );
    }
    if (
      feaTariffPreManHourParametersRepairDescription !== undefined &&
      feaTariffPreManHourParametersRepairDescription !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreManHourParameters.RepairDescription',
        <any>feaTariffPreManHourParametersRepairDescription
      );
    }
    if (
      feaTariffPreMaterialCostParametersPaginationPageNumber !== undefined &&
      feaTariffPreMaterialCostParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.Pagination.PageNumber',
        <any>feaTariffPreMaterialCostParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPreMaterialCostParametersPaginationPageSize !== undefined &&
      feaTariffPreMaterialCostParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.Pagination.PageSize',
        <any>feaTariffPreMaterialCostParametersPaginationPageSize
      );
    }
    if (
      feaTariffPreMaterialCostParametersPaginationSortOrder !== undefined &&
      feaTariffPreMaterialCostParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.Pagination.SortOrder',
        <any>feaTariffPreMaterialCostParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPreMaterialCostParametersPaginationSortColumn !== undefined &&
      feaTariffPreMaterialCostParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.Pagination.SortColumn',
        <any>feaTariffPreMaterialCostParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPreMaterialCostParametersShopCode !== undefined &&
      feaTariffPreMaterialCostParametersShopCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.ShopCode',
        <any>feaTariffPreMaterialCostParametersShopCode
      );
    }
    if (
      feaTariffPreMaterialCostParametersMode !== undefined &&
      feaTariffPreMaterialCostParametersMode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.Mode',
        <any>feaTariffPreMaterialCostParametersMode
      );
    }
    if (
      feaTariffPreMaterialCostParametersRepairCode !== undefined &&
      feaTariffPreMaterialCostParametersRepairCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMaterialCostParameters.RepairCode',
        <any>feaTariffPreMaterialCostParametersRepairCode
      );
    }
    if (
      feaTariffPreLabourRateParametersPaginationPageNumber !== undefined &&
      feaTariffPreLabourRateParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreLabourRateParameters.Pagination.PageNumber',
        <any>feaTariffPreLabourRateParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPreLabourRateParametersPaginationPageSize !== undefined &&
      feaTariffPreLabourRateParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreLabourRateParameters.Pagination.PageSize',
        <any>feaTariffPreLabourRateParametersPaginationPageSize
      );
    }
    if (
      feaTariffPreLabourRateParametersPaginationSortOrder !== undefined &&
      feaTariffPreLabourRateParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreLabourRateParameters.Pagination.SortOrder',
        <any>feaTariffPreLabourRateParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPreLabourRateParametersPaginationSortColumn !== undefined &&
      feaTariffPreLabourRateParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreLabourRateParameters.Pagination.SortColumn',
        <any>feaTariffPreLabourRateParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPreLabourRateParametersShopCode !== undefined &&
      feaTariffPreLabourRateParametersShopCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreLabourRateParameters.ShopCode',
        <any>feaTariffPreLabourRateParametersShopCode
      );
    }
    if (
      feaTariffPreLabourRateParametersMode !== undefined &&
      feaTariffPreLabourRateParametersMode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreLabourRateParameters.Mode',
        <any>feaTariffPreLabourRateParametersMode
      );
    }
    if (
      feaTariffPreMarkupParametersPaginationPageNumber !== undefined &&
      feaTariffPreMarkupParametersPaginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.Pagination.PageNumber',
        <any>feaTariffPreMarkupParametersPaginationPageNumber
      );
    }
    if (
      feaTariffPreMarkupParametersPaginationPageSize !== undefined &&
      feaTariffPreMarkupParametersPaginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.Pagination.PageSize',
        <any>feaTariffPreMarkupParametersPaginationPageSize
      );
    }
    if (
      feaTariffPreMarkupParametersPaginationSortOrder !== undefined &&
      feaTariffPreMarkupParametersPaginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.Pagination.SortOrder',
        <any>feaTariffPreMarkupParametersPaginationSortOrder
      );
    }
    if (
      feaTariffPreMarkupParametersPaginationSortColumn !== undefined &&
      feaTariffPreMarkupParametersPaginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.Pagination.SortColumn',
        <any>feaTariffPreMarkupParametersPaginationSortColumn
      );
    }
    if (
      feaTariffPreMarkupParametersLocationId !== undefined &&
      feaTariffPreMarkupParametersLocationId !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.LocationId',
        <any>feaTariffPreMarkupParametersLocationId
      );
    }
    if (
      feaTariffPreMarkupParametersShopCode !== undefined &&
      feaTariffPreMarkupParametersShopCode !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.ShopCode',
        <any>feaTariffPreMarkupParametersShopCode
      );
    }
    if (
      feaTariffPreMarkupParametersMarkup !== undefined &&
      feaTariffPreMarkupParametersMarkup !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.Markup',
        <any>feaTariffPreMarkupParametersMarkup
      );
    }
    if (
      feaTariffPreMarkupParametersInlandShop !== undefined &&
      feaTariffPreMarkupParametersInlandShop !== null
    ) {
      queryParameters = queryParameters.set(
        'FeaTariffPreMarkupParameters.InlandShop',
        <any>feaTariffPreMarkupParametersInlandShop
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<FeaTariff>(
      'get',
      `${this.basePath}/fea-tariffs/${encodeURIComponent(String(id))}`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will upload Tariff Sheet by tariff Id
   *
   * @param id tariff id
   * @param fileId uploaded file identifier
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaTariffsIdUploadPost(
    id: number,
    fileId?: number,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public feaTariffsIdUploadPost(
    id: number,
    fileId?: number,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public feaTariffsIdUploadPost(
    id: number,
    fileId?: number,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public feaTariffsIdUploadPost(
    id: number,
    fileId?: number,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling feaTariffsIdUploadPost.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (fileId !== undefined && fileId !== null) {
      queryParameters = queryParameters.set('fileId', <any>fileId);
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/fea-tariffs/${encodeURIComponent(String(id))}/upload`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves a list of all repairs.
   * This method returns all repair records available in the system. The response is              formatted as an HTTP 200 OK  status with the list of repairs in the response body. If no repairs are found,              an empty list is returned.
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaTariffsRepairsGet(
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public feaTariffsRepairsGet(
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public feaTariffsRepairsGet(
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public feaTariffsRepairsGet(
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/fea-tariffs/repairs`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves all TP (Tariff Point) ranges.
   * This method returns a collection of TP ranges, which represent tariff point              configurations. The data is fetched asynchronously from the underlying service.
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaTariffsTpRangesGet(
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public feaTariffsTpRangesGet(
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public feaTariffsTpRangesGet(
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public feaTariffsTpRangesGet(
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/fea-tariffs/tp_ranges`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
